import React, { useState, useEffect } from "react";

const Step1 = ({ data, onChange, onNext }) => {
  return (
    <div>
      <h2>Step 1</h2>
      <input
        type="text"
        value={data.step1 || ""}
        onChange={(e) => onChange("step1", e.target.value)}
        placeholder="Enter Step 1 Data"
      />
      <button onClick={onNext}>Next</button>
    </div>
  );
};

const Step2 = ({ data, onChange, onNext, onBack }) => {
  return (
    <div>
      <h2>Step 2</h2>
      <input
        type="text"
        value={data.step2 || ""}
        onChange={(e) => onChange("step2", e.target.value)}
        placeholder="Enter Step 2 Data"
      />
      <button onClick={onBack}>Back</button>
      <button onClick={onNext}>Next</button>
    </div>
  );
};

const Step3 = ({ data, onBack }) => {
  return (
    <div>
      <h2>Step 3</h2>
      <p>Review Your Data:</p>
      <pre>{JSON.stringify(data, null, 2)}</pre>
      <button onClick={onBack}>Back</button>
    </div>
  );
};

const MultiStepForm = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({ step1: "", step2: "" });
  const [completedSteps, setCompletedSteps] = useState([true, false, false]);

  // Add beforeunload event listener to warn on page refresh
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "Are you sure you want to refresh?";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const goToStep = (step) => {
    if (completedSteps[step]) setCurrentStep(step);
  };

  const handleNext = () => {
    const nextStep = currentStep + 1;
    if (nextStep < completedSteps.length) {
      const updatedSteps = [...completedSteps];
      updatedSteps[nextStep] = true;
      setCompletedSteps(updatedSteps);
      setCurrentStep(nextStep);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div>
      <h1>Multi-Step Form with Refresh Warning</h1>
      <div className="tabs">
        {["Step 1", "Step 2", "Step 3"].map((label, index) => (
          <button
            key={index}
            disabled={!completedSteps[index]}
            onClick={() => goToStep(index)}
            style={{
              fontWeight: currentStep === index ? "bold" : "normal",
              marginRight: "5px",
            }}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="form-content">
        {currentStep === 0 && (
          <Step1 data={formData} onChange={handleChange} onNext={handleNext} />
        )}
        {currentStep === 1 && (
          <Step2
            data={formData}
            onChange={handleChange}
            onNext={handleNext}
            onBack={handleBack}
          />
        )}
        {currentStep === 2 && <Step3 data={formData} onBack={handleBack} />}
      </div>
    </div>
  );
};

export default MultiStepForm;
